module.exports = ( Api, StepConfigSource ) ->
  return {

    restrict: 'A'

    scope:
      getStepConfig: '&stepConfigSourceList'
      getCountries:  '&countries'

    template: require('./stepConfigSourceList.html')

    controller: ( $scope, $element ) ->

      # =========================
      # -------- Private --------
      # =========================

      currentPage = undefined

      resetPage = () ->
        currentPage         = 1
        $scope.filters.page = 1

      getParams = ( filters ) ->
        offset = ( filters.page - 1 ) * 10
        params =
          step:   filters.stepConfig.id
          offset: offset

        if filters.country
          params.country = filters.country.id

        if filters.name
          params.name = filters.name

        return params

      loadSources = ( filters ) ->
        params = getParams( filters )

        $scope.isLoadingSources = true
        $scope.sources = []
        Api.Engine.get( params ).$promise.then ( response ) ->
          $scope.totalSources = response.count
          sources             = response.results
          $scope.sources      = sources.map ( source ) -> new StepConfigSource( source )
          $scope.isLoadingSources = false

      onStepConfigChange = ( stepConfig ) ->
        $scope.filters.stepConfig = stepConfig
        resetPage()
        loadSources( $scope.filters )

      # =========================
      # --------- Public --------
      # =========================

      $scope.onPageChange = () ->

        # diPaginate fires page change first time around which causes loading the sources twice, so we ensure that the
        # requested page is different from the current one.
        return unless currentPage != $scope.filters.page


        # Upon new page selection, dirPaginate sets the bound variable (equivalent to $scope.filters.page = page).
        # So we need a manual way to workout the currentPage
        currentPage = $scope.filters.page

        loadSources( $scope.filters )

      $scope.onNameChange = () ->
        resetPage()
        loadSources( $scope.filters )

      $scope.onCountryChange = ( country ) ->
        $scope.filters.country = country
        resetPage()
        loadSources( $scope.filters )

      # =========================
      # ---- Initialisation -----
      # =========================

      $scope.totalSources = undefined
      $scope.countries    = $scope.getCountries()

      $scope.filters =
        stepConfig: undefined
        page:       undefined
        name:       undefined
        country:    undefined

      resetPage()

      $scope.$watch( $scope.getStepConfig, onStepConfigChange )

      return
  }
